import { ReactNode, useMemo } from 'react';

import { useBoolean } from '../../utils/useBoolean';

import DialogContext from './context';

export interface DialogProviderProps {
  children: ReactNode;
}
export default function DialogProvider({ children }: DialogProviderProps) {
  const { state: isOpen, setTrue: open, setFalse: close } = useBoolean();

  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return <DialogContext.Provider value={value}>{children}</DialogContext.Provider>;
}
